var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 260,
    viewBox: "0 0 262 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_885_2734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.179 113.184L231.033 114.04V114.022L240.57 123.583C224.65 139.371 146.031 217.509 130.167 233.294C123.29 226.416 104.865 207.962 84.9215 187.987C58.9395 161.964 30.3815 133.361 21.427 124.416C37.3126 108.61 115.946 30.4743 131.829 14.7067C136.054 18.9467 164.906 47.8318 190.345 73.2998C209.8 92.7768 227.258 110.255 230.179 113.184Z",
    fill: "#0321F8",
    stroke: "#0FF0DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.167 123.549L130.185 212.942L41.8125 124.415L131.795 35.0399L220.167 123.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.451 84.3352H87.0508V155.034H173.451V84.3352Z",
    fill: "#0321F8",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.563 83.9022H87.9844C86.9553 83.9022 86.1211 84.7343 86.1211 85.7608V97.7605C86.1211 98.787 86.9553 99.6191 87.9844 99.6191H171.563C172.592 99.6191 173.426 98.787 173.426 97.7605V85.7608C173.426 84.7343 172.592 83.9022 171.563 83.9022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.087 108.477H100.352V121.181H113.087V108.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.087 129.427H100.352V142.131H113.087V129.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.15 108.477H145.414V121.181H158.15V108.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.576 127.609H139.84V140.312H152.576V127.609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.474 108.477H122.738V121.181H135.474V108.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.474 129.427H122.738V142.131H135.474V129.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.067 138.001C173.851 136.847 173.897 135.709 174.185 134.655C177.083 137.084 181.366 137.061 184.287 134.516L184.318 134.511L188.082 138.715C189.293 140.087 189.167 142.176 187.791 143.384L183.683 147.022L183.158 144.215C178.953 144.998 174.856 142.211 174.067 138.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.494 123.69L165.489 118.378C166.861 117.154 168.956 117.281 170.167 118.653L172.504 121.283L159.482 123.709L159.494 123.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.552 162.588L174.807 154.904L145.891 180.542C144.519 181.765 142.424 181.639 141.197 180.27L139.294 178.14C138.326 177.029 138.224 175.45 138.973 174.181C140.629 171.355 140.389 167.656 138.061 165.072C136.834 163.703 135.251 162.852 133.552 162.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.732 146.631C127.095 143.232 124.32 140.763 121.069 140.336C119.624 140.137 118.72 140.336 118.72 140.336L117.005 131.588L178.646 120.108L180.292 129.286C177.259 129.851 174.93 131.805 174.183 134.639C173.91 135.691 173.849 136.832 174.065 137.986C174.853 142.196 178.95 144.983 183.155 144.2L184.805 153.01L123.18 164.487C123.18 164.487 123.164 164.49 123.161 164.474L121.515 155.68C125.736 154.894 128.517 150.826 127.729 146.615L127.732 146.631Z",
    fill: "#0321F8",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.139 148.014C154.327 155.427 152.48 155.932 148.98 149.161C147.615 146.365 143.321 146.326 140.698 145.798C135.309 142.848 147.192 140.732 146.633 136.624C146.955 134.886 147.36 128.323 150.463 131.586C151.906 133.851 153.471 137.804 156.596 138.077C158.338 138.398 164.933 138.799 161.646 141.897C159.376 143.336 155.413 144.897 155.139 148.014Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_885_2734",
    x: 0.71875,
    y: 0,
    width: 260.559,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.18767 0 0 0 0 0.926514 0 0 0 0 0.837852 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_885_2734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_885_2734",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEvents);
export default __webpack_public_path__ + "static/media/empty-events.98e400d1a924b80dad08679743a8b75c.svg";
export { ForwardRef as ReactComponent };